import React from 'react'

// Home now serves the new static DataPrime site design as-is
// (public/dp-site/index.html — its own nav, preloader, cursor fx, footer, JS/CSS)
// via a full-viewport iframe, instead of the old React-built home sections.
const Home = () => {
  return (
    <iframe
      src="/dp-site/index.html"
      title="DataPrime Home"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        border: 'none',
        margin: 0,
        padding: 0,
      }}
    />
  )
}

export default Home
